import { render } from "./RelRetiradosTable.vue?vue&type=template&id=04c58674"
import script from "./RelRetiradosTable.vue?vue&type=script&lang=js"
export * from "./RelRetiradosTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__